import { Link } from "react-router-dom"
import { useDispatch } from "react-redux"
import { format } from "date-fns"

export default function InformesPresupuestosCard({id, addressEvent, name_client, dateReception, dateSend, numberDocument, totalCoeficiente}) {


    return (
        <div className="flex flex-row justify-center">            
            <div className="flex border-b border-slate-500">
            {/* <div className="flex flex-row  bg-slate-300 hover:text-slate-400"> "flex flex-row bg-green-600 hover:text-slate-400"*/}
            <Link to={`/presupuestos/${id}`}>
            <div className='flex flex-row text-[11px] hover:text-[14px] pt-2  text-sky-200 hover:text-orange-400'>
                <div className='w-12'>                    
                    <p className="font-bold text-center">{numberDocument}</p>
                </div>
                <div className='pl-2 w-72'>                    
                    <p className="font-bold text-left pl-2">{name_client}</p>
                </div>
                <div className='pl-2 w-80'>                    
                    <p className="font-bold text-left pl-2">{addressEvent}</p>
                </div>
                <div className='w-20'>                    
                    <p className="font-bold text-center">{dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}</p>
                </div>
                <div className='w-20'>                    
                    <p className="font-bold text-center">{dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}</p>
                </div>
                <div className="w-20">
                    <p className="font-bold text-center">{totalCoeficiente}</p>
                </div>              
                
                </div>
            </Link>                              
            </div>                
        </div>
    )
}